<template>
  <article class="auc-paid">
    <group gutter="0">
      <x-input
        v-if="channel === 5"
        title="收车合同价"
        :max="11"
        placeholder="请输入寄售车辆的收车合同价"
        v-model="purchase_price"
        :class="{'price-verify': !isVerify}"
      >
        <span slot='right' style="color: #000">元</span>
      </x-input>
      <x-input title="实收金额" :max="11" placeholder="请输入金额数" v-model="paid_amount" :class="{'price-verify': !isVerify}">
        <span slot='right' style="color: #000">元</span>
      </x-input>
      <datetime class="datetime" title="收款日期" placeholder="请选择日期" :min-year="1970"  format="YYYY-MM-DD" confirm-text="完成" cancel-text="取消" v-model="infoPaid.paid_date" ></datetime>
    </group>
    <group title="备注">
      <x-textarea placeholder="请输入内容（非必填）" class=""
                  ref=autosize v-model="infoPaid.paid_note">
      </x-textarea>
    </group>
    <group class="" title="凭证照片 (最多可添加6张)">
    </group>
    <div class="choice-pic-list">
      <ul class="fn-clear" v-if="images.length<1">
        <li>
          <a>
            <img src="" alt="" @click="toUpload(0)">
            <em :class="{iconclose:false}"></em>
          </a>
        </li>
      </ul>
      <ul class="fn-clear" v-else-if="images.length<6">
        <li v-for="(src, item) in images" :key="item">
          <a v-if="src">
            <img :src="src" alt="" @click="toUpload(item)">
            <em :class="{iconclose:true}" @click="deleteImages(item)"></em>
          </a>
        </li>
        <li>
          <a>
            <img alt="" @click="toUpload()">
            <em :class="{iconclose:false}"></em>
          </a>
        </li>
      </ul>
      <ul class="fn-clear" v-else-if="images.length>=6">
        <li v-for="(src, item) in images" :key="item">
          <a v-if="src">
            <img :src="src" alt="" @click="toUpload(item)">
            <em :class="{iconclose:true}" @click="deleteImages(item)"></em>
          </a>
        </li>
      </ul>
    </div>
    <div class="btn-bottom">
      <div class="btn-fix">
        <a class="btn" @click.stop.prevent="onSubmit">确认收款</a>
      </div>
    </div>
    <!-- 价格提醒 begin-->
    <x-alert v-model="dialogShow" button-text="我知道了" title="金额防错提示" class="verify-dialog">
      <h4 class="tips">当前的单位为“元”，你所输入的以下金额小于100元，请确认金额输入是否正确。</h4>
      <p v-for="(item, index) in dialogContent" :key="index">{{item}}</p>
    </x-alert>
    <!-- 价格提醒 end -->
  </article>
</template>

<script>
import {
  XTextarea,
  Datetime,
  XInput,
  Group,
  XAlert
} from '@lx-frontend/cvux'
import util from '../../common/util'
export default {
  components: {
    XTextarea,
    Datetime,
    XInput,
    Group,
    XAlert
  },
  data() {
    return {
      dialogShow: false,
      isVerify: true, // 是否执行金额验证
      dialogContent: [], // 提示文本
      images: [],
      purchase_price: '',
      paid_amount: '',
      infoPaid: {
        // actual_purchase_price: '',
        actual_paid_amount: '', // 实收金额，单位： 分
        paid_date: '',
        paid_note: '',
        receipt_image: ''
      },
      order_id: 0,
      category: '',
      isClicked: false,
      channel: ''
    }
  },
  created() {
    this.order_id = this.$route.params.order_id
    // 路由参数 match ： 用于区分是否为 撮合订单收款 提交
    // 路由参数 category 用于 区分 撮合订单确认收款提交
    // 参数为：enquiries 询价撮合订单确认收款提交
    // 参数为：auction 流拍撮合订单确认收款提交
    this.category = this.$route.query.category === 'enquiries' ? 'enquiries' : 'auction'
    // 判断这条线索是否为寄售
    this.$nextTick(() => {
      this.channel = +this.$route.query.channel
    })
  },
  methods: {
    validataPrice(keys) {
      for (let item of keys) {
        const val = this[item.key]
        if (!val) {
          this.showToast(item.msg || '请输入实收金额')
          return false
        } else if (!util.regexpMap.regexp_decimals.test(val)) {
          this.showToast('金额必须为正数并且至多2位小数')
          return false
        } else if ((val * 100) > 2000000000) {
          this.showToast('请输入0~20000000的价格')
          return false
        }
      }
      return true
    },
    validate() {
      let prices
      if (this.$route.query.channel === '5') {
        prices = [
          { key: 'purchase_price', msg: '请输入寄售车辆的收车合同价' },
          { key: 'paid_amount', msg: '请输入实收金额' }
        ]
      } else {
        prices = [ { key: 'paid_amount', msg: '请输入实收金额' } ]
      }
      if (!this.validataPrice(prices)) return false // 校验金额类的输入框
      if (!this.infoPaid.paid_date) {
        this.showToast('请选择收款日期')
        return false
      }
      if (this.isVerify) {
        const ispass = this.priceVerify()
        if (!ispass) {
          return false
        }
      }
      return true
    },
    onSubmit () {
      if (!this.validate()) return
      const _this = this
      if (!_this.infoPaid.paid_date) {
        this.showToast('请选择收款日期')
        return false
      }
      if (this.isVerify) {
        const ispass = this.priceVerify()
        if (!ispass) {
          return false
        }
      }
      let image = ''
      if (_this.images.length > 0) {
        _this.images.forEach(v => {
          image = `${image},${v}`
        })
      }
      if (image.substr(0, 1) === ',') {
        _this.infoPaid.receipt_image = image.substr(1)
      }
      _this.infoPaid.actual_paid_amount = (_this.paid_amount * 100).toFixed(0)
      if (+this.$route.query.channel === 5) { // 当线索来源为寄售的时候，才需要这个合同价
        _this.infoPaid.purchase_price = (_this.purchase_price * 100).toFixed(0)
      }
      if (_this.isClicked) {
        return false
      }
      _this.isClicked = true
      if (this.$route.query.type === 'match') {
        // 撮合订单 => 收款
        // 这里需要通过this.category判断是 询价撮合订单确认收款 还是 流拍撮合订单确认收款
        // 如果为 enquiries 则是 询价、auction或其他则是 流拍
        let postMethod = this.category === 'enquiries' ? 'postEnquiryCompleteOrder' : 'postCompleteOrder'
        let pathUrl = this.category === 'enquiries' ? `${this.order_id}/order_complete` : this.order_id
        // 动态提交方法 , 方法名和提交URL地址都是动态判断的.
        _this.$rest.match[postMethod](_this.infoPaid, pathUrl).then((res) => {
          if (res.code === 0) {
            // 确认收款成功需要跳转回 撮合订单详情 页面
            // 这时候加上 this.category ，从而跳转到 撮合订单详情 页面 用于区分是 询价订单还是流拍订单
            this.$router.push({ path: '/auction/match/order/' + this.order_id, query: { type: this.category } })
            this.showToast('提交成功')
          } else {
            this.isClicked = false
            this.showToast(res.message)
          }
        }, (res) => {
          this.isClicked = false
          this.showToast(res.message)
        })
      } else {
        _this.$rest.auction.savePaid(_this.infoPaid, this.order_id).then((res) => {
          if (res.code === 0) {
            this.$router.push('/auction/orderDetail/' + this.order_id)
            this.showToast('提交成功')
          } else {
            this.isClicked = false
            this.showToast(res.message)
          }
        }, (res) => {
          this.isClicked = false
          this.showToast(res.message)
        })
      }
    },
    // 金额防错提示
    priceVerify() {
      if (this.paid_amount < 100) {
        this.dialogContent.push(`实收金额：${this.paid_amount}元`)
      }
      if (this.dialogContent.length > 0) {
        this.dialogShow = true
        this.isVerify = false
        return false
      }
      return true
    },
    toUpload(item) {
      this.$wechat.promise.then(wx => {
        wx.uploadImage((res) => {
          let mediaId = res.serverId
          // 通知后台同步刚上传的文件
          this.$rest.wx.getImageByAuction(null, mediaId).then((res) => {
            if (res.code === 0) {
              if (typeof item !== 'undefined') {
                this.$set(this.images, item, res.data.url)
              } else {
                this.$set(this.images, this.images.length, res.data.url)
              }
            } else {
              this.showToast(res.message)
            }
          })
        })
      }, wx => {
        console.log('微信JSSDK校验错误:', wx.res)
      })
    },
    deleteImages(item) {
      this.images.splice(item, 1)
    }
  }
}
</script>

<style rel="stylesheet/less" lang="less">
@import '../../stylesheets/base/mixin/common.less';
  @w2: 75rem;
  .auc-paid {
      .weui_dialog {
        background: #fff;
      }
      .title {
        font-size: 30/@w2;
        color: #010101;
        padding-top: 20/@w2;
        opacity: 0.7;
      }
      .choice-pic-list {
        margin-left: -0.4rem;
        /*padding: 0 0 0.05333333rem 0;*/
        ul {
          margin-top: 30/@w2;
        }
      }
    }
</style>
